import { render, staticRenderFns } from "./Subscribe.vue?vue&type=template&id=10abb7d2&scoped=true&"
import script from "./Subscribe.vue?vue&type=script&lang=ts&"
export * from "./Subscribe.vue?vue&type=script&lang=ts&"
import style0 from "./Subscribe.vue?vue&type=style&index=0&id=10abb7d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10abb7d2",
  null
  
)

export default component.exports